import { render, staticRenderFns } from "./withdrawList.vue?vue&type=template&id=63e18afe&scoped=true"
import script from "./withdrawList.vue?vue&type=script&lang=js"
export * from "./withdrawList.vue?vue&type=script&lang=js"
import style0 from "./withdrawList.vue?vue&type=style&index=0&id=63e18afe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e18afe",
  null
  
)

export default component.exports